import React, { Component } from 'react';
import classnames from 'classnames';
import cloudImage from 'Assets/img/icon-cloud-upload.svg';
import InformationIcon from 'Components/icons/information-icon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import './MerchantUploadDocuments.scss';
import { uploadDocument, deleteDocument } from 'Apis/imageMatcherApi';
import FailedFiles from 'Components/FailedFiles/FailedFiles.jsx';
import ResponseBanner from 'Components/cards/ResponseBanner';
import MerchantPassFiles from 'Components/MerchantPassFiles/MerchantPassFiles.jsx';
import counterpart from 'counterpart';
import PropTypes from 'prop-types';
import ImagePortal from 'Containers/ImagePortal';
export class MerchantUploadDocuments extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      failedFile: [],
      passFile: [],
      intervalIds: [],
      isError: false,
      errorDescription: '',
      fileCount: 0,

    };


    this.attachBindings();
  }

  attachBindings() {
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.increaseProgressBarStatus = this.increaseProgressBarStatus.bind(this);
    this.validateFileType = this.validateFileType.bind(this);
    this.validateFileSize = this.validateFileSize.bind(this);
    this.isDocumentAlreadyUploaded = this.isDocumentAlreadyUploaded.bind(this);
    this.displayFileList = this.displayFileList.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.showErrorBanner = this.showErrorBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.handleProgressBarStatus = this.handleProgressBarStatus.bind(this);
    this.getFileName = this.getFileName.bind(this);
    this.displayFailFileList = this.displayFailFileList.bind(this);
    this.getCardBrandFileSizeLimit = this.getCardBrandFileSizeLimit.bind(this);
    this.getFileSizeValidationError = this.getFileSizeValidationError.bind(this);
    this.deleteFileImportSelect = this.deleteFileImportSelect.bind(this);
  }

  componentDidMount() {
    this.setState({
      passFile: this.props.uploadFileList
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isCSVLoaded !== this.props.isCSVLoaded && this.props.isCSVLoaded == false ) {
      this.setState({
        passFile: []
      })
    }
  }

  getFileName(fileName, fileLengthLimit) {
    let newFileName = fileName.length > fileLengthLimit ? fileName.substring(0, fileLengthLimit).concat('...') : fileName;
    return newFileName;
  }

  get dragAndDropLabelAndBrowseButtonBlock() {
    return (
      <div className="input-cover-merchant">
        <div><span className="drag-drop-file-label">{counterpart('globalTranslate.takeAction.dragAndDrop')}&nbsp;</span>
          <span><LinkInlineButton
            action={this.selectFile}
            extraClass="file-upload-browse"
          >{counterpart('globalTranslate.takeAction.browseComputer')}</LinkInlineButton>
          </span>
        </div>
        {<div className="allow-file-type">
          {this.props.isFileImportUploadDoc ? counterpart('globalTranslate.fileImport.fileType') :
          counterpart('globalTranslate.takeAction.fileType')  
          }
        </div>
        }
      </div>
    );
  }

  selectFile = () => {
    this.input.click();
  };


  closeBanner() {
    this.setState({
      isError: false
    });
  }


  showErrorBanner() {

    if (this.state.isError) {
      return (
        <div>
          <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title={counterpart('globalTranslate.takeAction.errorOccurred')}
            description={this.state.errorDescription}
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText={counterpart('globalTranslate.takeAction.dismiss')}
            primaryButtonActionValue=""
            primaryButtonText="OKAY"
            primaryButtonAction={this.closeBanner}
          />
          </ImagePortal>
        </div>
      );
    }

  }
  get fileUploadInitialBlock() {
    const fileDragClass = classnames('file-drag-merchant', {
      hover: this.state.hoverState,
    });
    return (
      <div
        className={fileDragClass}
        onDragOver={this.handleDragOver}
        onDragLeave={this.handleDragOver}
        onDrop={this.handleFileSelect}
      >
        <input
          type="file"
          tabIndex="-1"
          ref={(x) => this.input = x}
          className="input"
          name="sample-test"
          multiple={!this.props.isFileImportUploadDoc}
          onChange={this.handleFileSelect}
        />
        {<img src={cloudImage} alt="icon" className="uploadImg" />}
        {this.dragAndDropLabelAndBrowseButtonBlock}
      </div>);
  }

  get tooltipIconBlock() {
    return (
      <div className="information-icon-file-upload">
        <InformationBubble
          tooltipContent="Upload your spreadsheet containing your notices and merchant IDs. Max file name length 80 characters."
          extraClass="information-icon-file-upload"
        ><InformationIcon navIcon />
        </InformationBubble>
      </div>
    );
  }

  handleDragOver(e) {
    if ('preventDefault' in e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const hoverState = e.type === 'dragover' ? 'hover' : null;
    this.setState({
      hoverState
    });
  }



  handleFileSelect = (e) => {
    this.handleDragOver(e);
    const file = (e.target.files && e.target.files) || (e.dataTransfer.files && e.dataTransfer.files);
    let failedFiles = [];
    let passFiles = this.state.passFile;
    let passObject = '';
    let count = this.state.fileCount;

    let totalFiles = file.length + this.state.passFile.length;
    if (this.props.isFileImportUploadDoc)
      {
        [...file]?.forEach((newfile) => {
          let validationTypeResult = this.validateFileType(newfile);
          let validationSizeResult = this.validateFileSize(newfile, this.props.acquirerCode,this.props.cardBrandCode);
           if (validationTypeResult.status === true && validationSizeResult.status === true)
           {
            passObject = { file: newfile, status: 'SUCCESS', documentName: '', response: '', size: newfile.size }
            ++count;
            passFiles.push(passObject);
            this.setState({
              passFile: passFiles,
              fileCount: count,
              failedFile: [],
            }, () => {
              this.props.csvLoaded(true);
              this.props.fileUploaded(true);
              this.props.updateNewFile(newfile);
            })
          }
           else {
            let failedObject =  { 
              file: newfile, 
              errorMsg: validationTypeResult.status == false ? validationTypeResult.errorMsg : validationSizeResult.errorMsg
            };
            failedFiles.push(failedObject);  
            this.setState({
              passFile: [] ,
              failedFile: failedFiles ,
            }, () => {
              this.props.csvLoaded(false);
              this.props.fileUploaded(false);
            })
           }
        });
      }
    else if (totalFiles > 5) {
      this.setState(
        {
          isError: true,
          errorDescription: counterpart('globalTranslate.takeAction.failedToUploadFiles')
        }
      )
    } else {
      [...file]?.forEach(newfile => {
        let validationTypeResult = this.validateFileType(newfile);
        let validationSizeResult = this.validateFileSize(newfile, this.props.acquirerCode,this.props.cardBrandCode);
        let validateIfAlreadyUploaded = this.isDocumentAlreadyUploaded(newfile);
        if (validationTypeResult.status === true && validationSizeResult.status === true && validateIfAlreadyUploaded == false) {
          count = count + 1;
          passObject = { file: newfile, status: 'PENDING', documentName: '', response: '', size: newfile.size }

          passFiles.push(passObject);
          this.setState({
            passFile: passFiles,
            fileCount: count,
            failedFile: []
          }, () => {
            if (this.state.fileCount === 0) {
              this.props.fileUploaded(false, this.state.passFile);
            } else {
              this.props.fileUploaded(true, this.state.passFile);
            }
          }
          )

          uploadDocument(newfile)
            .then(res => {
              const ua = window.navigator.userAgent;
              const isIE = ua.indexOf('Trident/') || ua.indexOf('MSIE');
              let originalFileName = res.data.originalDocumentName;
              if (isIE > 0) {
                let fullFilePath = res.data.originalDocumentName.split("\\");
                originalFileName = fullFilePath[fullFilePath.length - 1];
              }

              this.handleProgressBarStatus(originalFileName);
              let elem = document.getElementById(newfile.name);
              elem.style.width = 100 + '%';
              passFiles = [... this.state.passFile];
              passFiles.map(files => {
                if (files.file.name === originalFileName) {
                  files.status = "SUCCESS";
                  files.response = res;
                  files.documentName = res.data.documentName;
                }
              })
              this.setState({
                passFile: passFiles,
                fileCount: this.state.fileCount - 1
              }, () => {
                if (this.state.fileCount === 0) {
                  this.props.fileUploaded(false, this.state.passFile);
                } else {
                  this.props.fileUploaded(true, this.state.passFile);
                }

              }
              );
            }).catch((error) => {

              let fileName = this.getFileName(newfile.name, 55);
              let failedObject = { file: newfile, errorMsg: `Something went wrong for file ${fileName}` };
              failedFiles.push(failedObject);

              if (passFiles.length > 1) {
                let remainingFiles = passFiles.filter(files => {
                  return files.file.name !== newfile.name;
                })
                passFiles = remainingFiles;
              } else {
                passFiles.pop();
              }
              this.handleProgressBarStatus(newfile.name);
              this.setState({
                failedFile: failedFiles,
                passFile: passFiles,
                fileCount: this.state.fileCount - 1
              }, () => {
                if (this.state.fileCount === 0) {
                  this.props.fileUploaded(false, this.state.passFile);
                } else {
                  this.props.fileUploaded(true, this.state.passFile);
                }

              }
              )

              console.log('FAILURE!!', error.message);
            });

          this.increaseProgressBarStatus(newfile);


        }
        else {
          let failedObject = '';
          let fileNames = this.getFileName(newfile.name, 60);
          if (validateIfAlreadyUploaded === true) {
            this.setState(
              {
                isError: true,
                errorDescription: `Selected file ${fileNames} is already uploaded`
              }
            )
          }
          else if (validationTypeResult.status == false) {
            failedObject = { file: newfile, errorMsg: validationTypeResult.errorMsg }
            failedFiles.push(failedObject);
          } else {
            failedObject = { file: newfile, errorMsg: validationSizeResult.errorMsg }
            failedFiles.push(failedObject);
          }

          this.setState({
            failedFile: failedFiles
          })
        }

      }

      );

    }

    e.target.value = '';

  };





  handleProgressBarStatus(originalFileName) {
    let fileObj = this.state.intervalIds.filter(files => {
      return files.filename === originalFileName;
    });
    let newintervalIds = this.state.intervalIds.filter(files => {
      return files.filename !== originalFileName;
    })
    this.setState(
      {
        intervalIds: newintervalIds
      }
    )
    clearInterval(fileObj[0].id);

  }


  validateFileType(file) {
    let failedObj = '';
    if (!this.props.isFileImportUploadDoc && (file.type === 'image/tiff' || file.type === 'application/pdf' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || 
    file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' )) {
      failedObj = { status: true, errorMsg: '' };
      return failedObj;
    } else if (this.props.isFileImportUploadDoc && file.type === 'text/csv' ) {
        failedObj = { status: true, errorMsg: '' };
        return failedObj;
    }
     else {
      let fileName = this.getFileName(file.name, 55);
      failedObj = { status: false, errorMsg: `${counterpart('globalTranslate.takeAction.fileName')} ${fileName} is not a valid file type` };
      return failedObj;
    }
  }

  getCardBrandFileSizeLimit() { 
    const cardBrandCode = this.props.cardBrandCode;
    switch (cardBrandCode) {
      case 'DI':
        return 15728640;
      case 'VI':
        return 10485760;
      case 'MC':
        return 10485760;
      case 'AX':
        return 1048576;
      case 'PD':
        return 2097152;
      default:
        return 10485760;
  }
}
getFileSizeValidationError(fileName) {
  const cardBrandFileSizeLimit = this.getCardBrandFileSizeLimit();
  if(this.props.cardBrandCode === 'PD') {
    return `${counterpart('globalTranslate.takeAction.fileName')} ${fileName} exceeds file size limit of ${Math.floor((cardBrandFileSizeLimit)/1000000)} MB.`  
  }
  else {
    return `${counterpart('globalTranslate.takeAction.fileName')} ${fileName} size exceeds ${Math.floor((cardBrandFileSizeLimit)/1000000)} MB.`
  }
}

  validateFileSize(file, acquirerCode,cardBrandCode) {
    let failedObj = '';
    const cardBrandFileSizeLimit = this.getCardBrandFileSizeLimit();
    let totalFilesSize= Object.values(this.state.passFile).reduce((t, {size}) => t + size, 0) + file.size;
    if(( file.size > 1048576 || totalFilesSize > 1048576 ) && acquirerCode === 'MXP') {
      failedObj = { status: false, errorMsg: counterpart('globalTranslate.takeAction.prosaUploadDocErrorMessage') };
      return failedObj;
    } 
    if(( file.size > 10485760 || totalFilesSize > 10485760 ) && cardBrandCode === 'MC') {
      failedObj = { status: false, errorMsg: counterpart('globalTranslate.takeAction.MCUploadDocErrorMessage') };
      return failedObj;
    }
    if(( file.size > 1048576 || totalFilesSize > 1048576 ) && acquirerCode === 'EMD') {
      failedObj = { status: false, errorMsg: counterpart('globalTranslate.takeAction.prosaUploadDocErrorMessage') };
      return failedObj;
    }

    if(file.size <= cardBrandFileSizeLimit) {
      failedObj = { status: true, errorMsg: '' };
      return failedObj;
    } else {
      let fileName = this.getFileName(file.name, 60);
      failedObj = { status: false, errorMsg: this.getFileSizeValidationError(fileName)};
      return failedObj;
    }
  }

  isDocumentAlreadyUploaded(file) {
    let doc = this.state.passFile.filter(docs => {
      return docs.file.name === file.name;
    })
    if (doc.length !== 0) {
      return true;
    } else {
      return false;
    }
  }


  increaseProgressBarStatus(file) {
    let width = 1;
    let id = setInterval(frame, 1000);

    let jsondata = { id: id, filename: file.name }

    this.state.intervalIds.push(jsondata);
    function frame() {

      let elem = document.getElementById(file.name);

      if (width >= 75) {
        clearInterval(id);
      } else {
        width++;
        if (elem !== null) {
          elem.style.width = width + '%';
        }
      }
    }
  }

  displayFileList() {
    let tempArray = [...this.state.passFile];
    let reverseFileList = tempArray.reverse();
    return (
      reverseFileList.map((file, key) => {
        let widths = 0;
        let ele = document.getElementById(file.file.name);
        if (ele != null) {
          widths = ele.style.width;
        }
        return (
          <MerchantPassFiles
            files={file}
            keys={key}
            width={widths}
            deleteFile={ this.props.isFileImportUploadDoc ? this.deleteFileImportSelect : this.deleteFile}
            fileUploaded={this.props.fileUploaded}
          />
        );

      }
      ));
  }

  displayFailFileList() {
    return (this.state.failedFile.map(failFile => {
      return (<FailedFiles
        failedFile={failFile}
      />)
    })
    )
  }

  deleteFileImportSelect = () => {
    this.setState(
      {
        passFile: [] ,
        fileCount : 0,
      } , () => {
        this.props.csvLoaded(false)
        this.props.fileUploaded(false) 
      });
  };

  deleteFile = (index) => {
    let tempArray = [...this.state.passFile];
    let reverseFileList = tempArray.reverse();
    let fileToDelete = reverseFileList[index];

    deleteDocument(fileToDelete.documentName)
      .then(res => {
        let remainingFiles = this.state.passFile.filter(file => {
          return file.file.name !== fileToDelete.file.name;
        })
        this.setState(
          {
            passFile: remainingFiles
          }, () => {
            if (this.state.fileCount === 0) {
              this.props.fileUploaded(false, this.state.passFile);
            } else {
              this.props.fileUploaded(true, this.state.passFile);
            }

          }
        )
      })

  }

  render() {
    let heights = this.state.failedFile.length * 55 + this.state.passFile.length * 55 + 200;
    return (

      <div className="action-pane-merchant-upload">
        {this.showErrorBanner()}


        <div className="content-styles-merchant" style={{ height: heights }}>
          { (this.props.isFileImportUploadDoc &&  this.props.isCSVLoaded) ? "" : this.fileUploadInitialBlock}
          {
            (this.state.failedFile.length > 0) && this.displayFailFileList()
          }

          {
            (this.state.passFile.length > 0) &&
            (
              <div>
                <div className="seperator-merchant">
               {counterpart('globalTranslate.export.fileName')}
                </div>
                <div className="seperator-merchant-line"></div>
              </div>
            )
          }
          {
            (this.state.passFile.length > 0) && this.displayFileList()
          }
        </div>


      </div>
    );
  }
}

MerchantUploadDocuments.propTypes = {
  isFileImportUploadDoc: PropTypes.bool,
  isCSVLoaded : PropTypes.bool, 
  csvLoaded : PropTypes.func,
}

MerchantUploadDocuments.defaultProps = {
  isFileImportUploadDoc: false,
  isCSVLoaded : false ,
  csvLoaded : () => {}
}

export default MerchantUploadDocuments;